<template>
    <b-sidebar id="add-new-subject-sidebar" :visible="isAddNewSchoolGradeSidebarActive" bg-variant="white"
      sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
      @change="(val) => $emit('update:is-add-new-school-grade-sidebar-active', val)">
      <template #default="{ hide }">
        <div class="
            d-flex
            justify-content-between
            align-items-center
            content-sidebar-header
            px-2
            py-1
          ">
          <h5 class="mb-0">Add Grade</h5>
          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>
        <zape-gallery-model :props_hideShowModel="showImageModel" @modelClose="modelClose"
          @saveCategoryImage="saveImage" />
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
            <validation-provider #default="validationContext" name="Grade Name" rules="required">
              <b-form-group label="Grade Name" label-for="Grade Name">
                <b-form-input id="Grade-Name" v-model="grade_data.grade_name" autofocus
                  :state="getValidationState(validationContext)" trim />
  
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
  
            <template v-if="getFileExtensionFromUrl(grade_data.grade_img) == 'json'">
              <LottieView :url="grade_data.grade_img" :forEditTopics="true" :key="keyForLottie" />
            </template>
            <template v-else-if="getFileExtensionFromUrl(grade_data.grade_img) == 'lottie'">
              <DoLottieView :url="grade_data.grade_img" :forEditTopics="true" :id="`school_img_${uuidv4()}`"
                :key="keyForLottie" />
            </template>
            <template v-else>
              <img style="width: 200px; height: 150px" :src="grade_data.grade_img" />
            </template>
  
            <br />
            <br />
            <div class="d-flex gap-2">
              <b-button variant="primary" @click="showgalleryimage">
                <span class="d-none d-sm-inline">Image gallery</span>
              </b-button>
              <upload-image @saveUploadImage="saveUploadImage" />
            </div>
            <div class="d-flex bg-light text-light align-items px-3 py-2"
              style="position: absolute; bottom: 0%; left: 0%; width: 100%">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="submit" @click="hide"
                :disabled="submitbutton">
                Add
              </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" style="margin-left: 10px"
                variant="outline-secondary" @click="hide">
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </template>
  
  <script>
  import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BCol,
    BFormFile,
    BFormSelect,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import Ripple from "vue-ripple-directive";
  import LottieView from "../../../components/question/LottieView.vue";
  import DoLottieView from "../../../components/question/DoLottieView.vue";
  import { v4 as uuidv4 } from 'uuid';
  export default {
    components: {
      ZapeGalleryModel: () => import("../../../components/Model/ZapeGalleryModel.vue"),
      UploadImage: () => import("../../../components/Model/UploadImage.vue"),
      BSidebar,
      DoLottieView,
      LottieView,
      BCol,
      BForm,
      BFormGroup,
      BFormInput,
      BFormInvalidFeedback,
      BButton,
      BFormFile,
      vSelect,
      ValidationProvider,
      ValidationObserver,
      uuidv4
    },
    directives: {
      Ripple,
    },
    model: {
      prop: "isAddNewSchoolGradeSidebarActive",
      event: "update:is-add-new-school-grade-sidebar-active",
    },
    props: {
        isAddNewSchoolGradeSidebarActive: {
        type: Boolean,
        required: true,
      },
      selectSchoolId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        grade_data: {
          grade_name: "",
          grade_img:
            "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg",
        },
        post_grade_data: "",
        showImageModel: false,
        keyForLottie: 0,
      };
    },
    computed: {
      submitbutton() {
        return !(
          this.grade_data.grade_name.length > 0 &&
          this.grade_data.grade_img.length > 0 &&
          this.grade_data.grade_img !== "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg"
        );
      },
    },
    methods: {
      uuidv4,
      getFileExtensionFromUrl(url) {
        if (!url) return '';
        const path = url.split('?')[0].split('#')[0];
        const extension = path.split('.').pop();
  
        if (extension === path) return '';
  
        return extension;
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      resetForm() {
        this.grade_data = {
            grade_name: "",
            grade_img:
            "https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg",
        };
        this.validated = false;
      },
      onSubmit() {
        const SchoolId = this.selectSchoolId; 
        this.grade_data.schoolId = SchoolId;
        console.log("log info" , this.grade_data);
        this.$emit("sendgradedata", this.grade_data);
      },
    
      saveUploadImage(url) {
        this.grade_data.grade_img = url;
      },
      modelClose(modelState) {
        this.showImageModel = modelState;
      },
      saveImage(url) {
        this.grade_data.grade_img = url;
      },
      showgalleryimage() {
        this.showImageModel = true;
      },
    },
  };
  </script>
  